// extracted by mini-css-extract-plugin
module.exports = {"widgetRow":"_cde3ae2"};